module.exports = __webpack_public_path__ + "media/de_de_s3_Siegfrid.1c572c39.oga";